export const USER_SESSION_KEY = 'user_session';

export const USER_SETTINGS = 'user_settings';
